
export default function VideoShowcase() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Experience <span className="text-emerald-600">Luxury Glamping</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Take a virtual tour of our stunning glamping retreats and discover what makes OED Glamping Retreat Developments the premier choice for luxury outdoor experiences.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden">
            <div className="aspect-video">
              <iframe
                src="https://www.youtube.com/embed/XsqCUcg4AOY"
                title="OED Glamping Retreat Developments - Luxury Outdoor Experience"
                className="w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                aria-label="OED Glamping promotional video showcasing luxury outdoor accommodations and retreat experiences"
              ></iframe>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-landscape-line text-emerald-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Stunning Locations</h3>
              <p className="text-gray-600">
                Carefully selected pristine natural settings across breathtaking landscapes
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-home-smile-line text-emerald-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Luxury Comfort</h3>
              <p className="text-gray-600">
                Premium amenities and modern conveniences in harmony with nature
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-leaf-line text-emerald-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Sustainable Design</h3>
              <p className="text-gray-600">
                Eco-friendly construction and operations that protect our environment
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
